import { HttpClient } from "@angular/common/http";
import { inject, Inject, Injectable } from "@angular/core";
import { EnvConfig, Environment } from "@doc/core";
import { ApiUrls } from "../backoffice-urls";
import {
  BaseResponse,
  ConfigurationTypeDeleteRequest,
  ConfigurationTypeGetByIdResponse,
  ConfigurationTypeGetListRequest,
  ConfigurationTypeGetListResponse,
  ConfigurationTypeUpdateRequest,
  TemplateDeleteRequest,
  TemplateGetListRequest,
  TemplateGetListResponse,
} from "../models";

@Injectable({
  providedIn: "root",
})
export class SettingService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllConfigType(body: ConfigurationTypeGetListRequest) {
    const link = this.apiUrl + ApiUrls.getConfigTypes;
    return this.http.post<ConfigurationTypeGetListResponse>(link, body);
  }

  getConfigType(id: number) {
    const link = this.apiUrl + ApiUrls.getConfigType + `/${id}`;
    return this.http.get<ConfigurationTypeGetByIdResponse>(link);
  }

  deleteConfigType(body: ConfigurationTypeDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteConfig;
    return this.http.post<BaseResponse>(link, body);
  }

  updateConfigType(body: ConfigurationTypeUpdateRequest) {
    const link = this.apiUrl + ApiUrls.updateConfig;
    return this.http.post<BaseResponse>(link, body);
  }

  getAllTemplates(body: TemplateGetListRequest) {
    const link = this.apiUrl + ApiUrls.getTemplates;
    return this.http.post<TemplateGetListResponse>(link, body);
  }

  getAllSelectedTemplates() {
    const link = this.apiUrl + ApiUrls.getAllSelectedTemplates;
    return this.http.get<any>(link);
  }

  updateSelectedTemplate(body: any) {
    const link = this.apiUrl + ApiUrls.updateSelectedTemplate;
    return this.http.post<any>(link, body);
  }

  getChipData() {
    const link = this.apiUrl + ApiUrls.getChipData;
    return this.http.get<any>(link);
  }

  getAllTicketTemplate(body: any) {
    const link = this.apiUrl + ApiUrls.getAllTicketTemplate;
    return this.http.post<BaseResponse>(link, body);
  }

  getTemplate(id: any) {
    const link = this.apiUrl + ApiUrls.getTemplate;
    return this.http.post<any>(link, { id });
  }

  deleteTemplate(id: number) {
    const link = this.apiUrl + ApiUrls.deleteTemplate + `/${id}`;
    return this.http.post<any>(link, { id });
  }

  getAllConfiguration(id: any) {
    const link = this.apiUrl + ApiUrls.GetAllConfiguration;
    return this.http.post<any>(link, id);
  }

  getConfigurationByCode(id: number) {
    let link = this.apiUrl + ApiUrls.GetConfigurationByCode;
    link = `${link}/${id}`;
    return this.http.get<any>(link);
  }

  createConfiguration(id: any) {
    const link = this.apiUrl + ApiUrls.CreateConfiguration;
    return this.http.post<any>(link, id);
  }

  updateConfiguration(body: any) {
    const link = this.apiUrl + ApiUrls.UpdateConfiguration;
    return this.http.put<any>(link, body);
  }

  deleteConfiguration(id: any) {
    let link = this.apiUrl + ApiUrls.DeleteConfiguration;
    link = `${link}/${id}`;
    return this.http.post<any>(link, id);
  }

  getApplicationConfiguration(body: any) {
    const link = this.apiUrl + ApiUrls.getApplicationConfiguration;
    return this.http.post<BaseResponse>(link, body);
  }

  getApplicationConfigurationById(id: number) {
    const link = this.apiUrl + ApiUrls.getApplicationConfigurationById(id);
    return this.http.get<BaseResponse>(link);
  }

  getAllowedUploadTypes() {
    const link = this.apiUrl + ApiUrls.getAllowedUploadTypes;
    return this.http.get<BaseResponse>(link);
  }

  getAllowedFileTypesList() {
    const link = this.apiUrl + ApiUrls.getAllowedFileTypesList;
    return this.http.get<BaseResponse>(link);
  }

  getAllowedFileTypesById(id: number | string) {
    const link = this.apiUrl + ApiUrls.getAllowedFileTypesById(id);
    return this.http.get<BaseResponse>(link);
  }

  createAllowedFileTypes(body: any) {
    const link = this.apiUrl + ApiUrls.createAllowedFileTypes;
    return this.http.post<BaseResponse>(link, body);
  }

  updateAllowedFileTypes(body: any) {
    const link = this.apiUrl + ApiUrls.updateAllowedFileTypes;
    return this.http.post<BaseResponse>(link, body);
  }

  deleteAllowedFileTypes(id: number | string) {
    const link = this.apiUrl + ApiUrls.deleteAllowedFileTypes(id);
    return this.http.post<BaseResponse>(link, {});
  }

  createApplicationConfiguration(body: any) {
    const link = this.apiUrl + ApiUrls.createApplicationConfiguration;
    return this.http.post<BaseResponse>(link, body);
  }

  updateApplicationConfiguration(id: number, body: any) {
    const link = this.apiUrl + ApiUrls.updateApplicationConfiguration(id);
    return this.http.post<BaseResponse>(link, body);
  }

  deleteApplicationConfiguration(id: number) {
    const link = this.apiUrl + ApiUrls.deleteApplicationConfiguration + `/${id}`;
    return this.http.post<BaseResponse>(link, {});
  }
}
